<script lang="ts" setup>
const { badgeType } = defineProps<{ badgeType: "limited" | "new" | "sale" }>();

const { t } = useI18n();

const vectorColor = computed(() => {
  return {
    "vector--limited": badgeType === "limited",
    "vector--new": badgeType === "new",
    "vector--sale": badgeType === "sale",
  };
});

const bgColor = computed(() => {
  return {
    "bg-dairy": badgeType === "limited",
    "bg-non": badgeType === "new",
    "bg-primary": badgeType === "sale",
  };
});

const label = computed(() => {
  switch (badgeType) {
    case "limited":
      return t("product.badge.limited");
    case "new":
      return t("product.badge.new");
    case "sale":
      return t("product.badge.sale");
  }

  return "";
});
</script>

<template>
  <div class="relative">
    <VectorWithStroke class="absolute -right-0.5 -top-0.5 h-[0.9rem] w-4" :class="vectorColor" />
    <div class="py-xs ps-sm rounded-e-full pe-[23px] text-sm font-medium uppercase text-white" :class="bgColor">
      {{ label }}
    </div>
  </div>
</template>

<style scoped>
.vector--limited {
  --esc-vector-fill-color: #73b7b6; /* dairy */
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
  --esc-vector-stroke-color: #fff;
  --esc-vector-stroke-width: 8;
}

.vector--new {
  --esc-vector-fill-color: #eab732; /* non */
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
  --esc-vector-stroke-color: #fff;
  --esc-vector-stroke-width: 8;
}

.vector--sale {
  --esc-vector-fill-color: #c81414; /* primary */
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
  --esc-vector-stroke-color: #fff;
  --esc-vector-stroke-width: 8;
}
</style>
